import type { APInvoiceHoldOrigin } from '@erp/rpc';

/**
 * The source-ERP record a hold sits on. Famous keeps holds in several places
 * (PO lines, sales-order lines, sales-load charges, …), so the badge names
 * where to go to release it.
 */
export type HoldOrigin = APInvoiceHoldOrigin;

/** An active Famous hold, labelled with the record it sits on. */
export interface HoldSource {
  value: string;
  origin: HoldOrigin;
  /** Source-ERP document number (and line), e.g. "24103 #3". */
  reference?: string;
}

export interface HoldSourceGroup {
  value: string;
  origin: HoldOrigin;
  count: number;
  references: string[];
}

/** Hold sources grouped by hold and record kind, in first-seen order. */
export function countHoldSources(
  sources: readonly HoldSource[],
): HoldSourceGroup[] {
  const groups = new Map<string, HoldSourceGroup>();
  const seenReferences = new Map<string, Set<string>>();
  for (const { value, origin, reference } of sources) {
    const key = `${value}|${origin}`;
    const group = groups.get(key) ?? {
      value,
      origin,
      count: 0,
      references: [],
    };
    const seen = seenReferences.get(key) ?? new Set<string>();
    group.count++;
    if (reference && !seen.has(reference)) {
      seen.add(reference);
      group.references.push(reference);
    }
    groups.set(key, group);
    seenReferences.set(key, seen);
  }
  return [...groups.values()];
}
